import { Input, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { InspectionRecordItem } from '@gkn-ili/views/dist/InspectionRecord';
import React from 'react';

const useStyles = makeStyles({
  error: {
    backgroundColor: tokens.colorPaletteRedBackground2,
  },
});

function isOutOfTolerance(item: InspectionRecordItem, value: string): false | [true, number] {
  if (item.type !== 'numberWithLimits') {
    return false;
  }
  const n = Number(value);
  if (n > item.upper) {
    return [true, n - item.upper];
  }
  if (n < item.lower) {
    return [true, n - item.lower];
  }
  return false;
}
function formatOutOfTolerance(OoT: number) {
  if (OoT < 0) {
    return OoT.toString();
  }
  return '+' + OoT.toString();
}

export function AppInspectionRecordInput(props: {
  item: InspectionRecordItem;
  className?: string;
  value?: string;
  disabled?: boolean;
  onChange: (newValue: null | string | number) => void;
}): JSX.Element {
  const styles = useStyles();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [hasFocus, setFocus] = React.useState(false);

  if (props.item.type === 'text') {
    return <Input className={props.className} value={props.value ? props.value : undefined} />;
  }
  const outOfTolerance = props.value ? isOutOfTolerance(props.item, props.value) : false;
  const value = props.value
    ? props.value.toString() +
      (!hasFocus && outOfTolerance ? '  ( ' + formatOutOfTolerance(outOfTolerance[1]) + ' )' : '')
    : '';
  return (
    <Input
      ref={inputRef}
      disabled={props.disabled}
      className={mergeClasses(props.className, !!outOfTolerance && !hasFocus && styles.error)}
      value={value}
      onChange={(_, data) => {
        const match = /^-{0,1}[0-9]*\.{0,1}[0-9]*/m.exec(data.value);
        props.onChange(match?.[0] ?? null);
      }}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      contentAfter={props.item.unit}
    />
  );
}
